// Registry of web storage keys. One source of truth so key strings don't
// duplicate across files (typo drift) and stay easy to find/rename.
//
// Convention: `rid:` prefix = localStorage (persists across sessions),
// `rid-` prefix = sessionStorage (this tab/session only). `utm_params` is
// historically unprefixed — kept as-is to avoid losing users' existing
// stored values.
export const STORAGE_KEYS = {
  /** localStorage — last authenticated email, pre-fills the login field. */
  LAST_LOGIN_EMAIL: "rid:last-login-email",
  /** localStorage — hint that passkey login has succeeded on this browser. */
  PASSKEY_DEVICE: "rid:passkey-device",
  /** sessionStorage — SetupWizard draft, survives refresh. */
  PARTNER_ONBOARDING: "rid-partner-onboarding",
  /** sessionStorage — captured UTM/click params for the whole session. */
  UTM_PARAMS: "utm_params",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
